
import { View } from 'backbone';
import util from 'util/Util.js';
import lengthTemplate from 'properties/main/picture.ejs';
import assetCollection from 'AssetCollection.js';
import listService from 'ListService';
import constants        from 'Constants';
import mobileSyncService from "../../../service/mobile/MobileSyncService";

class MainPictureView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = lengthTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]' : 'updateCheckboxAttributes',
            'change #assetSelect' : 'assetSelected',
            'change select' : 'updateSelectAttributes'
        };

        if (!this.model.get('asset')) {
            this.model.set('asset', 'None', {silent: true});
        }
        if (!this.model.get('maintainAspectRatio')) {
            this.model.set('maintainAspectRatio', 'false' , {silent: true});
        }
        if (!this.model.get('stretch')) {
            this.model.set('stretch', 'false', {silent: true});
        }
        if (!this.model.get('preLoad')) {
            this.model.set('preLoad', 'unchecked', {silent: true});
        }

        let mobileDesignerStyle = listService.mainKind === constants.KIND_MOBILE ? "display: none;" : "";
        this.model.set('mobileDesignerStyle', mobileDesignerStyle, constants.MODEL_SILENT);

        this.listenTo(this.model, 'change', this.render);
        //this.listenTo(this.model, 'change:width', this.adjustPictureSettings);
        //this.listenTo(this.model, 'change:height', this.adjustPictureSettings);
        return this;
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        this.model.set( propName, propVal );

    }


    updateCheckboxAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        this.model.set( propName, propVal);
        mobileSyncService.synchronizeMobileForm(this.model, this.model.get('factoryKey'), {key: propName, val: propVal} );
        //this.adjustPictureSettings();
    }

    assetSelected(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        if (propVal) {
            this.model.set( 'assetId', propVal );
            mobileSyncService.synchronizeMobileForm(this.model, this.model.get('factoryKey'), {key: 'assetId', val: propVal} );
        }


    }

    adjustPictureSettings() {
        let bStretch = util.isTrue(this.model.get('stretch'));
        let bMaintainRatio = util.isTrue(this.model.get('maintainAspectRatio'));

        let styleTag = '';
        if (bStretch && !bMaintainRatio) {
            styleTag = `height: 100%; width: 100%; max-height: ${util.extractNum(this.model.get('height'))}px ;max-width: ${util.extractNum(this.model.get('width'))}px`;
        }

        else if(bStretch && bMaintainRatio) {
            const picHeight = util.extractNum(this.model.get('height'));
            const picWidth = util.extractNum(this.model.get('width'));

            const imageToAdjust=$('#' + this.model.get('id') + ' .pf-selectable img');
        
            // Performing calculation based on real image size
            let naturalWidth = !imageToAdjust.prop('naturalWidth') ? 1 : imageToAdjust.prop('naturalWidth') ;
            let naturalHeight = !imageToAdjust.prop('naturalHeight') ? 1 : imageToAdjust.prop('naturalHeight');

            let adjustedHeight = picWidth * naturalHeight /  naturalWidth;
            let adjustedWidth = picHeight * naturalWidth / naturalHeight;
            
            adjustedHeight = isNaN(adjustedHeight) ? picHeight : adjustedHeight;
            adjustedWidth = isNaN(adjustedWidth) ? picWidth : adjustedWidth;

            styleTag = `max-width: ${picWidth}px;max-height: ${picHeight}px;height:${adjustedHeight}px;width:${adjustedWidth}px`;
        }

        this.model.set('pictureStyle', styleTag);
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        assetCollection.forEach( asset  => {
            var opt = document.createElement('option');
            opt.text = asset.get('name');
            opt.value = asset.get('id');
            
            var isImage = new RegExp('image/');
            if(isImage.test(asset.get('mimeType'))){
                $('#assetSelect').append(opt);
            }
                
        });

        if(this.model.get('assetId')) {
            $('#assetSelect').find("option[value='"+this.model.get('assetId')+"']").attr('selected', true);
        }

        $('#printQuality').find("option[value='" + this.model.get('printQuality')+"']").attr('selected', true);

        let bStretch = util.isTrue(this.model.get('stretch'));

        $(`input[name='stretch']`).prop('checked', bStretch );

        let bMaintainRatio = util.isTrue(this.model.get('maintainAspectRatio'));

        $(`input[name='maintainAspectRatio']`).prop('checked', bMaintainRatio );




        this.delegateEvents();
        return this;
    }

}

export default MainPictureView;
